/**
 * OMNIVASO i18n Module — English (en)
 * Source of truth. All other language files must mirror every key defined here.
 * DO NOT remove or rename keys without updating all language files.
 */
const en = {
    // ── Navigation ──────────────────────────────────────────────────────────
    nav: {
        home:            'Home',
        shop:            'Shop',
        cart:            'Cart',
        search:          'Search',
        articles:        'Articles',
        blog:            'Blog',
        about:           'About',
        contact:         'Contact',
        account:         'My Account',
        orders:          'My Orders',
        login:           'Login',
        logout:          'Logout',
        openMenu:        'Open Menu',
        closeMenu:       'Close Menu',
        skipToContent:   'Skip to content',
    },

    // ── Common Actions ───────────────────────────────────────────────────────
    actions: {
        readMore:        'Read More',
        viewAll:         'View All',
        learnMore:       'Learn More',
        back:            'Back',
        close:           'Close',
        save:            'Save',
        cancel:          'Cancel',
        submit:          'Submit',
        confirm:         'Confirm',
        delete:          'Delete',
        edit:            'Edit',
        add:             'Add',
        remove:          'Remove',
        search:          'Search',
        reset:           'Reset',
        next:            'Next',
        previous:        'Previous',
        loading:         'Loading...',
        tryAgain:        'Try Again',
        copy:            'Copy',
        share:           'Share',
        download:        'Download',
        upload:          'Upload',
        apply:           'Apply',
        clear:           'Clear',
    },

    // ── Status & Feedback ────────────────────────────────────────────────────
    status: {
        success:         'Success!',
        error:           'An error occurred. Please try again.',
        saved:           'Saved successfully.',
        notFound:        'Page not found.',
        comingSoon:      'Coming soon.',
        outOfStock:      'Out of Stock',
        inStock:         'In Stock',
        soldOut:         'Sold Out',
        new:             'New',
        sale:            'Sale',
        featured:        'Featured',
        noResults:       'No results found.',
        required:        'This field is required.',
        invalidEmail:    'Please enter a valid email address.',
    },

    // ── E-Commerce ───────────────────────────────────────────────────────────
    shop: {
        addToCart:       'Add to Cart',
        addedToCart:     'Added to Cart',
        viewCart:        'View Cart',
        checkout:        'Checkout',
        continueShopping:'Continue Shopping',
        orderSummary:    'Order Summary',
        orderTotal:      'Order Total',
        subtotal:        'Subtotal',
        shipping:        'Shipping',
        tax:             'Tax',
        discount:        'Discount',
        couponCode:      'Coupon Code',
        applyCoupon:     'Apply Coupon',
        quantity:        'Quantity',
        price:           'Price',
        total:           'Total',
        remove:          'Remove',
        emptyCart:       'Your cart is empty.',
        browseProducts:  'Browse Products',
        product:         'Product',
        products:        'Products',
        category:        'Category',
        categories:      'Categories',
        sortBy:          'Sort By',
        filterBy:        'Filter By',
        allProducts:     'All Products',
        searchProducts:  'Search products...',
        productDetails:  'Product Details',
        relatedProducts: 'Related Products',
        stockLeft:       'left in stock',
        freeShipping:    'Free Shipping',
        placeOrder:      'Place Order',
        orderConfirmed:  'Order Confirmed!',
        trackOrder:      'Track Order',
        orderNumber:     'Order Number',
        paymentMethod:   'Payment Method',
        billingAddress:  'Billing Address',
        shippingAddress: 'Shipping Address',
        firstName:       'First Name',
        lastName:        'Last Name',
        email:           'Email Address',
        phone:           'Phone Number',
        address:         'Address',
        city:            'City',
        province:        'Province / State',
        postalCode:      'Postal Code / ZIP',
        country:         'Country',
        secureCheckout:  'Secure Checkout',
        payWith:         'Pay with',
    },

    // ── Articles / Blog ──────────────────────────────────────────────────────
    articles: {
        by:              'By',
        publishedOn:     'Published on',
        minuteRead:      'min read',
        tags:            'Tags',
        share:           'Share this article',
        relatedArticles: 'Related Articles',
        allArticles:     'All Articles',
        noArticles:      'No articles found.',
        searchArticles:  'Search articles...',
    },

    // ── Search ───────────────────────────────────────────────────────────────
    search: {
        placeholder:     'Type to search products, articles, pages...',
        results:         'Results',
        noResults:       'No results found for',
        searching:       'Searching...',
        searchTip:       'Press ⌘K or Ctrl+K to search',
        quickSearch:     'Quick Search',
    },

    // ── Newsletter ───────────────────────────────────────────────────────────
    newsletter: {
        subscribe:       'Subscribe',
        subscribeTitle:  'Stay in the loop',
        subscribeDesc:   'Get the latest updates delivered to your inbox.',
        emailPlaceholder:'Enter your email',
        thankYou:        'Thank you for subscribing!',
        alreadySubscribed:'You are already subscribed.',
        privacyNote:     'We respect your privacy. Unsubscribe at any time.',
    },

    // ── Footer ───────────────────────────────────────────────────────────────
    footer: {
        rights:          'All rights reserved.',
        privacy:         'Privacy Policy',
        terms:           'Terms of Use',
        sitemap:         'Sitemap',
        poweredBy:       'Powered by',
        contactUs:       'Contact Us',
        followUs:        'Follow Us',
        quickLinks:      'Quick Links',
    },

    // ── Forms ────────────────────────────────────────────────────────────────
    forms: {
        email:           'Email',
        password:        'Password',
        confirmPassword: 'Confirm Password',
        username:        'Username',
        name:            'Name',
        message:         'Message',
        subject:         'Subject',
        send:            'Send',
        sending:         'Sending...',
        sent:            'Message sent!',
        signIn:          'Sign In',
        signUp:          'Sign Up',
        forgotPassword:  'Forgot Password?',
        rememberMe:      'Remember me',
        changePassword:  'Change Password',
        currentPassword: 'Current Password',
        newPassword:     'New Password',
    },

    // ── Language Selector ────────────────────────────────────────────────────
    i18n: {
        selectLanguage:  'Select Language',
        language:        'Language',
    },

    // ── 404 / Error Pages ────────────────────────────────────────────────────
    errors: {
        pageNotFound:    'Page Not Found',
        pageNotFoundDesc:'The page you are looking for doesn\'t exist or has been moved.',
        goHome:          'Go to Homepage',
        somethingWrong:  'Something went wrong',
        somethingWrongDesc: 'An unexpected error occurred. Your data is safe.',
        returnToStorefront: 'Return to Storefront',
    },
};

export default en;
